"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
/****************************************************************
 * This file is not autogenerated - it contains the code that    *
 * won't change when the package is updated                      *
 ****************************************************************/
var types_1 = require("./types");
exports.StagingUnstableRegions = [
  types_1.Region.R1A,
  types_1.Region.R1B,
  types_1.Region.R1G,
];
function reverseRegionMap() {
  var reverseRegionMap = new Map();
  Object.keys(types_1.Region).forEach(function (region) {
    var regionValue = types_1.Region[region];
    reverseRegionMap.set(regionValue, region);
  });
  return reverseRegionMap;
}
exports.reverseRegionMap = reverseRegionMap;
// This mapping is required for constructing the service urls in R1 unstable
exports.R1UnstableRegionMap =
  ((_a = {}),
  (_a[types_1.Region.R1A] = "alpha"),
  (_a[types_1.Region.R1B] = "beta"),
  (_a[types_1.Region.R1G] = "gamma"),
  _a);
// These are fixed as we do not expect to add more OCI Classic regions
var OcicRegion;
(function (OcicRegion) {
  OcicRegion["APAC_REGION"] = "APAC_REGION";
  OcicRegion["EMEA_REGION"] = "EMEA_REGION";
  OcicRegion["LAD_REGION"] = "LAD_REGION";
  OcicRegion["NORTH_AMERICA_REGION"] = "NORTH_AMERICA_REGION";
  OcicRegion["UK001"] = "UK001";
  OcicRegion["US001"] = "US001";
  OcicRegion["US002"] = "US002";
  OcicRegion["USDOD"] = "USDOD";
  OcicRegion["USGOV"] = "USGOV";
  OcicRegion["UKGOV"] = "UKGOV";
})((OcicRegion = exports.OcicRegion || (exports.OcicRegion = {})));
// These are fixed
var RegionLocation;
(function (RegionLocation) {
  RegionLocation[(RegionLocation["NorthAmerica"] = 0)] = "NorthAmerica";
  RegionLocation[(RegionLocation["SouthAmerica"] = 1)] = "SouthAmerica";
  RegionLocation[(RegionLocation["EMEA"] = 2)] = "EMEA";
  RegionLocation[(RegionLocation["APAC"] = 3)] = "APAC";
})((RegionLocation = exports.RegionLocation || (exports.RegionLocation = {})));
